import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "./ApiRequest";

// Prenotazione tavoli (modulo "bookings"): risposte JSON dirette, errori in `message`.
const B = "bookings";
export const GetBookingSettingsAPI = () => getRequest(`${B}/settings`);
export const SaveBookingSettingsAPI = (p) => putRequest(`${B}/settings`, p);
export const NewAgentTokenAPI = () => postRequest(`${B}/settings/agent-token`);
export const GetShiftsAPI = () => getRequest(`${B}/shifts`);
export const AddShiftAPI = (p) => postRequest(`${B}/shifts`, p);
export const SaveShiftAPI = (id, p) => putRequest(`${B}/shifts/${id}`, p);
export const DeleteShiftAPI = (id) => deleteRequest(`${B}/shifts/${id}`);
export const GetClosuresAPI = () => getRequest(`${B}/closures`);
export const AddClosureAPI = (p) => postRequest(`${B}/closures`, p);
export const DeleteClosureAPI = (id) => deleteRequest(`${B}/closures/${id}`);
export const GetAgendaAPI = (date) => getRequest(`${B}/?date=${date}`);
export const AddBookingAPI = (p) => postRequest(`${B}/`, p);
export const SetBookingAPI = (id, p) => patchRequest(`${B}/${id}`, p);
export const GetBookingStatsAPI = (days = 30) =>
  getRequest(`${B}/stats?days=${days}`);
export const GetRoomsAPI = () => getRequest(`${B}/rooms`);
export const AddRoomAPI = (p) => postRequest(`${B}/rooms`, p);
export const SaveRoomAPI = (id, p) => putRequest(`${B}/rooms/${id}`, p);
export const DeleteRoomAPI = (id) => deleteRequest(`${B}/rooms/${id}`);
export const SaveLayoutAPI = (id, tables) =>
  putRequest(`${B}/rooms/${id}/layout`, { tables });
export const GetFloorAPI = (date, time) =>
  getRequest(`${B}/floor?date=${date}${time ? `&time=${time}` : ""}`);
export const AssignTablesAPI = (bookingId, p) =>
  postRequest(`${B}/${bookingId}/tables`, p);
export const GetPanelSlotsAPI = (date, party = 1, exclude) =>
  getRequest(
    `${B}/slots?date=${date}&party=${party}${exclude ? `&exclude=${exclude}` : ""}`
  );
export const GetWeekAPI = (date) => getRequest(`${B}/week?date=${date}`);
export const SaveClosureAPI = (id, p) => putRequest(`${B}/closures/${id}`, p);
export const StartPauseAPI = (p) => postRequest(`${B}/settings/pause`, p);
export const EndPauseAPI = () => deleteRequest(`${B}/settings/pause`);

// --- My Bookings (agenda, contatore del menu) ---
// Prenotazioni In attesa: `total` da oggi in poi e, con from/to, quante per giorno.
export const GetPendingBookingsAPI = (from, to) =>
  getRequest(`${B}/pending${from && to ? `?from=${from}&to=${to}` : ""}`);

// --- Statistics (periodo dal/al) ---
export const GetBookingPeriodStatsAPI = (from, to) =>
  getRequest(`${B}/stats?from=${from}&to=${to}`);
